import { graphql } from "gql";

const MESSAGE_THREAD_FRAGMENT = graphql(`
  fragment MessageThread on MessageThread {
    id
    subject
    isStarred
    isPinned
    isSeen
    isNotification
    isInbox
    isDeleted
    isLocked
    isCreateMessage
    lockedUserId
    isExternal
    type
    fileCount
    linkCount
    sortTime
    createTime
    messageUserIdList
    participantUserIdList
    createMessageUserIdList
    accessUserIdList
    searchUserIdList
    notificationUserIdList
    tagIdList
    distributionGroupIdList
    calloutUserIdList
    emailUserIdList
    remindTime
    locale
    createdUserId
    unseenCount
    pendingEmailUserIdList
    relatedMessageThreadCount
    emailAddress
    lastMessage {
      ...LastMessage
    }
    removedUserList {
      ...RemovedUser
    }
    meRemovedUser {
      ...RemovedUser
    }
    task {
      ...Task
    }
    sortKeys {
      ...MessageThreadSortKeys
    }
    happycoWorkOrder {
      ...HappycoWorkOrder
    }
  }
`);

export default MESSAGE_THREAD_FRAGMENT;
